

<iframe
  src="/assets/verticalplayer/index.html" 
  style="position: fixed; inset: 0; border: none;"
  width="100%"
  height="100%"
  allow="autoplay; fullscreen">
</iframe>
